<template>
    <div>
        <vue-loading :loading="isLoading"></vue-loading>
        <div v-if="optimazing.isVisible" :class="[$prefixClass.card + '-stroke', 'optimization-progress']">
            <div class="optimization-progress__header display-space-between align-items-center">
                <h6 class="m-b-0">Optimization Progress</h6>
                <div>
                    <i v-if="isDetail" class="fas fa-chevron-down" @click="isDetail = !isDetail"></i>
                    <i v-else class="fas fa-chevron-up" @click="isDetail = !isDetail"></i>
                    <i v-if="showProgressBox" class="fal fa-times m-l-10" @click="getProcess"></i>
                </div>
            </div>
            <div v-if="isDetail" class="optimization-progress__content">
                <div v-if="optimazing.image" :class="['optimization-progress__process display-space-between align-items-center']">
                    <div class="p-r-24">
                        <div class="display-space-between align-items-center m-b-8">
                            <span class="fz-14 fw-600">{{ $t('optimize_image.components.optimizing_image') }}</span>
                            <a v-if="imageLogId" class="a-link fz-14" @click="onViewSummary({logId: imageLogId})">View details</a>
                            <span v-else class="fz-14">{{optimazing.image.count}}/{{optimazing.image.total}}</span>
                        </div>
                        <vue-progress-bar :percent="optimazing.image.percent">
                            <template slot="titleOuter">
                                {{optimazing.image.percent}}
                            </template>
                        </vue-progress-bar>
                    </div>
                    <i v-if="imageLogId" class="fas fa-check-circle fz-18 success-color"></i>
                    <i v-else class="fas fa-times-circle fz-18" @click="deleteOptimizeImages"></i>
                </div>
                <div v-if="optimazing.theme" :class="['optimization-progress__process display-space-between align-items-center', optimazing.image ? 'm-t-36' : '']">
                    <div class="p-r-24">
                        <div class="display-space-between align-items-center m-b-8">
                            <span class="fz-14 fw-600">{{ $t('optimize_image.components.optimizing_theme') }}</span>
                            <a v-if="themeLogId" class="a-link fz-14" @click="onViewSummary({logId: themeLogId, type: 'theme'})">View details</a>
                            <span v-else class="fz-14">{{ methodName }}</span>
                        </div>
                        <vue-progress-bar :percent="optimazing.theme.percent">
                            <template slot="titleOuter">
                                {{optimazing.theme.percent}}
                            </template>
                        </vue-progress-bar>
                    </div>
                    <i v-if="themeLogId" class="fas fa-check-circle fz-18 success-color"></i>
                    <i v-else class="fas fa-times-circle fz-18" @click="deleteOptimizeTheme"></i>
                </div>
            </div>
        </div>
        <modal-notification v-model="modalDetele" 
            @stopOptimizeImages="onStopOptimizeImages"
            @stopOptimizeTheme="onStopOptimizeTheme"
        >
        </modal-notification>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { types as typesAuth } from "@/modules/auth/constant"
import { types as typesOptimize } from '@/modules/optimize_image/constant'
import ModalNotification from '@/modules/optimize_image/components/ModalNotification'
import Pusher from "pusher-js"
import { store } from '@/main.js'
const pusher = new Pusher(`${process.env.VUE_APP_PUSHER_KEY}`, {
    cluster: "ap1"
});
export default {
    name: 'VueOptimizeProgress',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            imageLogId: 0,
            themeLogId: 0,
            methodName: '',
            modalDetele: {
                isVisible: false,
                title: '',
                description: '',
                action: '',
                btnText: 'Stop'
            },
            isDetail: true
        }
    },
    components: {
        ModalNotification
    },
    computed: {
        ...mapGetters({
            store: typesAuth.getters.GET_STORE
        }),
        optimazing: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        isVisible() {
            return this.optimazing.isVisible
        },
        showProgressBox() {
            return this.imageLogId && this.themeLogId || (!this.optimazing.theme && this.imageLogId) || (!this.optimazing.image && this.themeLogId)
        }
    },
    watch: {
        isVisible: {
            handler(value) {
                this.imageLogId = 0
                this.themeLogId = 0
                if ( value ) {
                    this.getMethodName()
                    for ( let property in this.optimazing ) {
                        if ( typeof(this.optimazing[property]) === 'object' && this.optimazing[property]) {
                            this.listenPusher(property)
                        }
                    }
                }
            },
            deep: true
        }
    },
    created() {
        this.getMethodName()
        for ( let property in this.optimazing ) {
            if ( typeof(this.optimazing[property]) === 'object' && this.optimazing[property]) {
                this.listenPusher(property)
            }
        }
    },
    methods: {
        ...mapActions({
            getLogDetail: typesOptimize.actions.GET_LOG_DETAIL,
            stopOptimizeTheme: typesOptimize.actions.STOP_OPTIMIZE_THEME,
            stopOptimizeImages: typesOptimize.actions.STOP_OPTIMIZE_IMAGES,
            getProcess: typesOptimize.actions.GET_PROCESS
        }),
        getMethodName() {
            if ( this.optimazing.theme && this.optimazing.theme.settings && this.optimazing.theme.settings.length > 0) {
                this.methodName = this.$t('optimize_image.components.'+this.optimazing.theme.settings[0])
                for( let i=1; i < this.optimazing.theme.settings.length; i++) {
                    setTimeout(() => {
                        if ( this.optimazing.theme.settings[i] ) {
                            this.methodName = this.$t('optimize_image.components.'+this.optimazing.theme.settings[i])
                        }
                    }, i*30*1000)
                }
            }
        },
        listenPusher( property ) {
            if ( property == 'image' ) {
                this.listenImagePusher()
            } else if ( property == 'theme' ) {
                this.listenThemePusher()
            }
        },
        async onStopOptimizeTheme() {
            let self = this
            this.isLoading = true
            this.modalDetele.isVisible = false
            await this.stopOptimizeTheme().then(res => {
                let { status = false, data = [] } = res.data
                if (status) {
                    self.optimazing.theme = null
                    self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                    store.commit('setStopOptimize', true)
                    store.commit('setOptimizing', self.optimazing.isVisible)
                    self.$emit('reload-data', {limitCompressImages: false})
                } else {
                    self.toastError({
                        title: "Error",
                        message: self.$t('app.errors.something_went_wrong'),
                        duration: 4
                    })
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            });
        },
        async onStopOptimizeImages() {
            let self = this
            this.isLoading = true
            this.modalDetele.isVisible = false
            await this.stopOptimizeImages().then(res => {
                let { status = false, data = [] } = res.data
                if (status) {
                    self.optimazing.image = null
                    self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                    store.commit('setStopOptimize', true)
                    store.commit('setOptimizing', self.optimazing.isVisible)
                    self.$emit('reload-data', {limitCompressImages: false})
                } else {
                    self.toastError({
                        title: "Error",
                        message: self.$t('app.errors.something_went_wrong'),
                        duration: 4
                    })
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            });
        },
        deleteOptimizeTheme() {
            this.modalDetele.title = this.$t('optimize_image.components.stop_optimize_theme')
            this.modalDetele.description = ''
            this.modalDetele.action = 'stopOptimizeTheme'
            this.modalDetele.isVisible = true
        },
        deleteOptimizeImages() {
            this.modalDetele.title = this.$t('optimize_image.components.stop_optimize_image'),
            this.modalDetele.description = this.$t('optimize_image.components.stop_optimize_image_desc')
            this.modalDetele.action = 'stopOptimizeImages'
            this.modalDetele.isVisible = true
        },
        async onViewSummary(modalData) {
            let {logId=0, type='image'} = modalData
            if (logId) {
                let self = this
                this.isLoading = true
                await this.getLogDetail({id: logId}).then(res => {
                    let { status = false, data = null } = res.data
                    if (status && (data.optimize_image_status === 'done' || data.optimize_theme_status === 'done')) {
                        if ( type === 'theme' && Number(data.details_count) <= 0 ) {
                            self.toastSuccess({
                                title: self.$t('optimize_image.errors.all_theme_optimized'),
                                message: self.$t('optimize_image.errors.no_codes_found'),
                                duration: 0
                            })
                        } else {
                            let totalSaved = type === 'theme' ? data.theme_total_origin_size - data.theme_total_optimize_size : data.image_total_origin_size - data.image_total_optimize_size
                            let modal = {
                                type: 'summary',
                                optType: type,
                                detail: {
                                    saved: totalSaved,
                                    images: Number(data.images_count),
                                    logId: data.id,
                                    files: Number(data.details_count)
                                }
                            }
                            self.showModalResult(modal)
                        }
                    } else {
                        self.toastError({
                            title: "Error",
                            message: self.$t('app.errors.something_went_wrong'),
                            duration: 4
                        })
                    }
                    self.isLoading = false
                }).catch(e => {
                    self.isLoading = false
                    console.log(e);
                });
            } else {
                self.toastError({
                    title: "Error",
                    message: "Log id was not found",
                    duration: 4
                })
            }
        },
        listenImagePusher() {
            let self = this;
            let channelName = "compress-images-channel-" + this.store.id
            let channel = pusher.subscribe(channelName)
            channel.unbind('compress-images')
            channel.bind("compress-images", function(data) {
                if ( self.optimazing.image ) {
                    if ( data.limitCompressImages ) {
                        self.optimazing.image = null
                        self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                        self.$emit('reload-data', {limitCompressImages: true})
                    } else {
                        self.optimazing.image.total = data.totalImages
                        self.optimazing.image.count += data.images
                        self.optimazing.image.percent += self.optimazing.image.percentPerImage * data.images
                        if ( data.limitCompfressImages ) {
                            channel.unbind("compress-images")
                            setTimeout(() => {
                                self.optimazing.image = null
                                self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                                store.commit('setOptimizing', self.optimazing.isVisible)
                                self.$emit('reload-data', {limitCompressImages: false})
                            }, 500)
                        } else if ( self.optimazing.image.count == self.optimazing.image.total ) {
                            channel.unbind("compress-images")
                            setTimeout(() => {
                                self.$emit('reload-data', {limitCompressImages: false})
                                if ( self.$router.currentRoute.name == self.$routerName.OPTIMIZE_IMAGE ) {
                                    self.optimazing.image = null
                                    self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                                    store.commit('setOptimizing', self.optimazing.isVisible)
                                    self.onViewSummary({logId: data.logId})
                                } else {
                                    self.isDetail = true
                                    self.imageLogId = data.logId
                                    store.commit('setOptimizing', !self.showProgressBox)
                                }
                            }, 500)
                        }
                    }
                }
            });
        },
        listenThemePusher() {
            let self = this
            let channelName = "optimize-theme-channel-" + this.store.id
            let channel = pusher.subscribe(channelName)
            channel.unbind('optimize-theme')
            channel.bind("optimize-theme", function(data) {
                if ( self.optimazing.theme ) {
                    switch (String(data.status)) {
                        case 'fail':
                            self.optimazing.theme = null
                            self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                            store.commit('setOptimizing', self.optimazing.isVisible)
                            self.toastError({
                                title: self.$t('app.errors.something_went_wrong'),
                                message: self.$t('app.errors.theme_fail'),
                                duration: 4
                            })
                        break;
                        case 'fail_theme_limit_text':
                            self.optimazing.theme = null
                            self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                            store.commit('setOptimizing', self.optimazing.isVisible)
                            self.toastError({
                                title: "Error",
                                message: self.$t('app.errors.theme_error'),
                                duration: 4
                            })
                        break;
                        case 'fail_theme_limit_20':
                            self.optimazing.theme = null
                            self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                            store.commit('setOptimizing', self.optimazing.isVisible)
                            self.toastError({
                                title: "Error",
                                message: self.$t('app.errors.theme_limit_20'),
                                duration: 4
                            })
                        break;
                        default:
                            self.optimazing.theme.percent = data.percent
                            if ( self.optimazing.theme.percent >= 100 ) {
                                channel.unbind("optimize-theme")
                                setTimeout(() => {
                                    self.$emit('reload-data', {limitCompressImages: false})
                                    if ( self.$router.currentRoute.name == self.$routerName.OPTIMIZE_IMAGE ) {
                                        self.optimazing.theme = null
                                        self.optimazing.isVisible = ( self.optimazing.image || self.optimazing.theme ) ? true : false
                                        store.commit('setOptimizing', self.optimazing.isVisible)
                                        self.onViewSummary({logId: data.logId, type: 'theme'})
                                    } else {
                                        self.themeLogId = data.logId
                                        store.commit('setOptimizing', !self.showProgressBox)
                                    }
                                }, 500)
                            }
                        break;
                    }
                }
            });
        }
    }
}
</script>
<style lang="scss">
    .optimization-progress {
        width: 345px;
        position: fixed;
        bottom: 24px;
        right: 110px;
        box-shadow: 1px 1px 10px 0 rgba(0, 18, 50, 0.1);
        z-index: 1001;
        &__header {
            height: 40px;
            background: $text-color;
            border-radius: 8px 8px 0 0;
            padding: 0 16px;
            i, h6 {
                color: $line-dark;
            }
            i {
                font-size: 18px;
                &:hover {
                    cursor: pointer;
                }
            }
        }
        &__content {
            padding: 22px 10px 30px 18px;
        }
        &__process {
            > div {
                width: 100%;
                .m-progress-bar{
                    display: block;
                    &-inner, &-outer {
                        display: block;
                    }
                }
            }
            .fa-times-circle {
                color: $line-dark;
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>